import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationPhilipMorrisData } from './Data';

enum PmiEventCondition {
  FLOWPAGE
}

interface PmiEventsItemState {
  condition: {
    flowpage: number;
  };
  id: number;
  on?: PmiEventCondition;
}

export interface IntegrationPhilipMorrisState extends BaseIntegrationState {
  decryptionEnabled: boolean;
  endpoint?: string;
  onlyAllowViewingInIframe: boolean;
  events: PmiEventsItemState[];
}

export class IntegrationPhilipMorrisModel extends BaseIntegration<
  IntegrationPhilipMorrisData,
  IntegrationPhilipMorrisState
> {
  parse(data: IntegrationPhilipMorrisData) {
    super.parse(data);

    this.state.decryptionEnabled = !!data.settings?.decryption_enabled;
    this.state.endpoint = data.settings?.endpoint;
    this.state.onlyAllowViewingInIframe = !!data.settings?.only_allow_viewing_in_iframe;
    this.state.events =
      data.settings?.pmi_events.map<PmiEventsItemState>((item) => {
        let condition: PmiEventCondition | undefined;

        switch (item.on) {
          case 'flowpage':
            condition = PmiEventCondition.FLOWPAGE;
            break;
        }

        return {
          condition: {
            flowpage: Number(item.condition.flowpage)
          },
          id: Number(item.id),
          on: condition
        };
      }) || [];
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
